module.exports = __webpack_public_path__ + "static/fonts/MaterialIcons-Regular.012cf6a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont/MaterialIcons-Regular.woff
// module id = q68U
// module chunks = 0